import { render, staticRenderFns } from "./PageHomeStudio.vue?vue&type=template&id=2008ee4a&scoped=true&"
import script from "./PageHomeStudio.vue?vue&type=script&lang=js&"
export * from "./PageHomeStudio.vue?vue&type=script&lang=js&"
import style0 from "./PageHomeStudio.vue?vue&type=style&index=0&id=2008ee4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2008ee4a",
  null
  
)

export default component.exports